import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'redux/store';
import axios from '../../utils/axios';
import { rejectWithError } from '../dispatchError';
import { IntegrationsState } from '../../@types/integrations';
import { translator } from 'translation/useTranslator';

const initialState: IntegrationsState = {
  isLoading: {},
  integrations: [],
  currentIntegration: null,
  hasError: false
};

const slice = createSlice({
  name: 'integrations',
  initialState,
  reducers: {
    startGetIntegrations(state) {
      state.isLoading.integrations = true;
    },
    getIntegrationsSuccess(state, action) {
      state.integrations = action.payload;
      state.isLoading.integrations = false;
      state.hasError = false;
    },
    getIntegrationsError(state) {
      state.integrations = [];
      state.isLoading.integrations = false;
      state.hasError = true;
    }
  }
});

export default slice.reducer;

export const getIntegrations = () => {
  return async () => {
    dispatch(slice.actions.startGetIntegrations());
    try {
      const response = await axios.get(`/integrations`);
      dispatch(slice.actions.getIntegrationsSuccess(response.data));
      return await Promise.resolve({
        result: response,
        defaultSuccessMessage: translator?.integrationsFetched() ?? 'Integrations fetched'
      });
    } catch (error: any) {
      dispatch(slice.actions.getIntegrationsError());
      return await rejectWithError({
        error: error,
        defaultErrorMessage:
          translator?.couldNotFetchIntegrations() ?? `Could not fetch integrations`
      });
    }
  };
};
